import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import RelectAndIntegrate1Image from "../../../Assets/Images/RelectAndIntegrate1Image.png";
import RelectAndIntegrateIcon from "../../../Assets/Images/RelectAndIntegrateIcon.png"

const LifeIntegration3 = () => {

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 }
        ]
    });


    const styles = StyleSheet.create({
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px",
        },
        image: {
            width: "574px",
            height: "300px",

        },
        content: {
            width: "570px",
            height: "710px",
            display: "flex",
            flexDirection: "column",
            marginTop : "10px"
        },
        imageContainer: {
            width: "574px",
            height: "300px",
        },
        contentDescription: {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            fontFamily : "Lato",
            fontWeight : 400,
            fontSize : "12px",
            lineHeight : "18px",
            color : "#245775"
        },
        icon: {
            width: "68px",
            height: "68px"
        },
        text: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "30px",
            color: "#426B88",
            marginBottom : "2px"
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: "#5795B2",
            borderBottom: "1px solid #5795B2"
        },
        title: {
            width: "183px",
            fontSize: "14px",
            fontFamily: "Lato",
            lineHeight: "18px",
            color: "#5795B2",
            fontWeight: 400,

        },
        titlebold: {
            fontWeight: 700
        },
        details: {
            fontSize: "10px",
            fontFamily: "Lato",
            lineHeight: "16px",
            color: "#5795B2",
            fontWeight: 400,
            width: "73px",
            textAlign: "right"

        },
        textbold: {
            fontWeight: 700
        },
        bold : {
            fontWeight : 700,
            marginTop: "10px",
            marginBottom: "10px"
        },
    });
    return (

        <View style={styles.pagewapper}>
            <View style={styles.header}>
                <View style={styles.title}>
                    <Text style={styles.titlebold}>Quadrant Flow</Text>
                    <Text>Life & Leadership Assessment</Text>
                </View>
                <View style={styles.details}>
                    <Text style={styles.textbold}>Rob Murray</Text>
                    <Text>Atlas Real Estate</Text>
                    <Text>Oct 18, 2024</Text>
                </View>
            </View>
            <View style={styles.content}>
                <Text style={styles.text}>LEADERSHIP INTEGRATION</Text>
                <View style={styles.contentDescription}>
                    <View>
                        <Text>1. What are the top leadership insights you gained from your results?</Text>
                        <Text>2. What areas of your leadership need the most improvement based on the results?</Text>
                        <Text>3. What leadership blind spots did the assessment reveal, and how will you address them?</Text>
                        <Text>4. How can you use your leadership strengths to impact your team or organization?</Text>
                        <Text>5. What steps will you take to create more balance in your leadership?</Text>
                        <Text>6. What leadership practice will you start right away based on your results?</Text>
                        <Text>7. What behavior changes will you make to improve your leadership style?</Text>
                        <Text>8. How do the results open new opportunities for leadership growth?</Text>
                        <Text>9. How can you manage any conflicts in your leadership style based on the results?</Text>
                        <Text>10. How will you hold yourself accountable for the actions suggested by your assessment?</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Deeper Reflection:</Text>
                        <Text>1. How have past leadership failures or successes shaped the leadership style reflected in your results?</Text>
                        <Text>2. In what ways do these results reveal deeper motivations driving your leadership decisions?</Text>
                        <Text>3. What underlying fears or desires do you need to address in order to grow as a leader, based on the assessment results?</Text>
                        <Text>4. How do these results suggest a shift in how you view power, influence, or authority in your leadership?</Text>
                        <Text>5. What long-term changes will you make to evolve your leadership based on the insights from the assessment?</Text>
                    </View>
                </View>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default LifeIntegration3